import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/ui/table';
import { StatusBadge } from 'components/ui/status-badge';
import { groupTallies, type TypeTally } from './gradingTypes';

interface GradingByTypeTableProps {
  tallies: TypeTally[];
}

/** Derived read-only from the test's questions, bucketed by presentation. */
export const GradingByTypeTable: React.FC<GradingByTypeTableProps> = ({ tallies }) => {
  const { t } = useTranslation();
  const groups = groupTallies(tallies);

  if (groups.length === 0) {
    return <p className="text-sm text-muted-foreground">{t('grading_by_type_empty')}</p>;
  }

  return (
    <div className="overflow-x-auto rounded-lg border border-border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{t('question_type')}</TableHead>
            <TableHead className="w-24 text-right">{t('count')}</TableHead>
            <TableHead className="w-24 text-right">{t('points')}</TableHead>
            <TableHead className="w-32">{t('grading')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {groups.map((row) => (
            <TableRow key={row.key}>
              <TableCell className="font-medium text-foreground">{t(row.labelKey)}</TableCell>
              <TableCell className="text-right tabular-nums text-muted-foreground">{row.count}</TableCell>
              <TableCell className="text-right tabular-nums text-muted-foreground">{row.points}</TableCell>
              <TableCell>
                {row.manual ? (
                  <StatusBadge tone="warning">{t('manual_graded')}</StatusBadge>
                ) : (
                  <StatusBadge tone="success">{t('auto_graded')}</StatusBadge>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default GradingByTypeTable;
